import {EntrepriseCorpsEtat} from "../../common/types/Types";
import {BYTable} from "../../common/views/BYTable";
import React, {useLayoutEffect, useState} from "react";
import {BYInput} from "../../common/inputs/BYInput";

interface EnterpriseCorpEtatListProps {
    data: EntrepriseCorpsEtat[];
    loading?: boolean;
}

const EnterpriseCorpEtatList = (props: EnterpriseCorpEtatListProps) => {
    const {data, loading} = props;
    const [searchText, setSearchText] = useState('');
    const [filteredEnterprises, setFilteredEnterprises] = useState<EntrepriseCorpsEtat[]>(data);

    useLayoutEffect(() => {
        const newEnterprises = data.filter((entCorp) => {
            const code = `${entCorp.entreprise.nom} ${entCorp.corpsEtat.libCorpsEtat}`.toUpperCase();
            const city = `${entCorp.entreprise.adresse} ${entCorp.entreprise.ville} ${entCorp.entreprise.cp}`.toUpperCase();
            const searchTextUpperCased = searchText.toUpperCase();

            return code.includes(searchTextUpperCased) || city.includes(searchTextUpperCased);
        });

        setFilteredEnterprises(newEnterprises);
    }, [searchText, data]);

    return <>

        <div className="mb-3">
            <BYInput type="text"
                   title="Rechercher"
                   placeholder="Nom, adresse, corps d'état, ville, cp, etc."
                   className="form-control"
                   value={searchText}
                   onChange={(e) => setSearchText(e.target.value)}/>
        </div>

        <BYTable
            loading={loading}
            data={filteredEnterprises}
            columns={['nomEntreprise', 'libCorpsEtat', 'adresseEntreprise', 'cpEntreprise', 'villeEntreprise', 'telephoneEntreprise', 'eMailEntreprise']}
            columnNames={['Nom', 'Corps d\'état', 'Adresse', 'CP', 'Ville', 'Téléphone', 'Email']}
            dataTransform={{
                'nomEntreprise': (entCorp) => entCorp.entreprise.nom,
                'libCorpsEtat': (entCorp) => entCorp.corpsEtat.libCorpsEtat,
                'adresseEntreprise': (entCorp) => entCorp.entreprise.adresse,
                'cpEntreprise': (entCorp) => entCorp.entreprise.cp,
                'villeEntreprise': (entCorp) => entCorp.entreprise.ville,
                'telephoneEntreprise': (entCorp) => entCorp.entreprise.telephone,
                'eMailEntreprise': (entCorp) => entCorp.entreprise.eMail,
            }}
            height={60}
        />

    </>;
};

export default EnterpriseCorpEtatList;
